import { localizePost, localizeLikeCount } from '@wix/communities-blog-client-common';

export default { localizePost, localizeLikeCount };
